export default __webpack_public_path__ + "retail15c2a1.png";